import {
  FlexAlignType,
  StyleSheet,
  TextStyle,
  useWindowDimensions,
} from 'react-native';

export const FORM_MAX_WIDTH = 400;

const getContentAlignment = (textAlign: TextStyle['textAlign']) => {
  if (!textAlign) {
    return {
      alignItems: 'center' as FlexAlignType,
      textAlign,
    };
  }

  return {
    left: {
      alignItems: 'flex-start' as FlexAlignType,
      textAlign,
    },
    center: {
      alignItems: 'center' as FlexAlignType,
      textAlign,
    },
    right: {
      alignItems: 'flex-end' as FlexAlignType,
      textAlign,
    },
    auto: {
      alignItems: 'flex-start' as FlexAlignType, // Default alignment for container
      textAlign, // Keep the text alignment property
    },
    justify: {
      alignItems: 'flex-start' as FlexAlignType, // Default alignment for container
      textAlign, // Keep the text alignment property
    },
  }[textAlign];
};

const createStyles = (style: any) => {
  let { width } = useWindowDimensions();
  const alignment = getContentAlignment(
    style?.textAlign as TextStyle['textAlign']
  );

  return StyleSheet.create({
    container: {
      display: 'flex',
      justifyContent: 'center',
      width,
      maxWidth: FORM_MAX_WIDTH,
      overflow: 'hidden',
      paddingTop: 32,
      ...alignment,
    },
    commonButtonWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 164,
      height: style.button?.height || 48,
      borderRadius: style.button?.borderRadius,
    },
    commonButtonContent: {
      height: style.button?.height || 48,
      width: 164,
    },
    commonButtonLabel: {
      fontWeight: '700',
      fontFamily: style.fontFamily,
    },
    prevButtonWrapper: {
      backgroundColor: '#FFFFFF',
      borderColor: style.button?.borderColor || '#0175FF',
      borderWidth: style.button?.borderWidth || 1,
      borderStyle: 'solid',
      marginRight: 16,
    },
    prevButtonLabel: {
      color:
        style.button?.prevButton?.color ||
        style.button?.borderColor ||
        '#0175FF',
    },
    nextButtonWrapper: {
      backgroundColor: style.button?.backgroundColor || '#0175FF',
    },
    nextButtonContent: {
      height: 48,
      width: 164,
    },
    nextButtonLabel: {
      color: style.button?.color || '#FFFFFF',
    },
    submitButton: {
      width: '100%',
    },
  });
};

export default createStyles;
